// "https://azusc-pkgloop-admin-web-dev.azurewebsites.net/api/v1.0/customer-portal/pre-built-packages/get/1"
import "../../WidgetModal.css";
import "react-day-picker/lib/style.css";

import React, { useEffect, useContext, useState } from "react";
import { Col, Row, Spinner, Button } from "react-bootstrap";
import { WidgetContext } from "../../../../../../../context/WidgetContext";
import UseGetLodgingVendors, { GetLodgingVendorsRequest, GetLodgingVendorsResponse } from "../../lodging/add-lodging/data-service-hooks/UseGetLodgingVendors";
import UseGetCustomVendors, { GetCustomVendorsRequest, GetCustomVendorsResponse } from "../../custom/add-custom/data-service-hooks/UseGetCustomVendors";
import UseGetGolfVendors, { GetGolfVendorsRequest, GetGolfVendorsResponse } from "../../golf/add-golf/data-service-hooks/UseGetGolfVendors";
import UseGetTransportVendors, { GetTransportVendorsRequest, GetTransportVendorsResponse } from "../../transportation/add-transportation/data-service-hooks/UseGetTransportVendors";
import { DatesAndGuests } from "../../../../widget-form/WidgetForm";
import PackageVendorCard from "../../../widget-modals/PackageVendorCard";
import { PreBuiltPkg } from "../Models/PreBuiltPkg";

interface props {
  pbPackage: PreBuiltPkg;
  datesAndGuests: DatesAndGuests;
  onSelectedPackage: (item: any) => void;
}

const PackageDetails: React.FC<props> = (props) => {
  const { startWidget, style, viewPortBreakPoint } = useContext(WidgetContext);

  const { pbPackage, onSelectedPackage } = props;
  const placeholderImgUrl = "https://images.unsplash.com/photo-1566073771259-6a8506099945?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80";

  // useEffect(() => {
  //   console.log("props.pbPackage", props.pbPackage);
  // }, [props.pbPackage]);

  return (
    <React.Fragment>
      <Row className="d-flex justify-content-center">
        <Col xs={12}>
          {/* Lodging Tab */}
          {pbPackage.preBuiltPkgVendors && pbPackage.preBuiltPkgVendors.some((pv: any) => pv.vendor.vendorType === "Lodging") && (
            <div className="pt-2 pb-2">
              <h4
                className="itinerary-font"
                style={{
                  color: style.headerColor,
                }}
              >
                Lodging
              </h4>

              <Row
                style={{
                  borderBottom: "2px solid",
                  borderColor: style.borderColor,
                }}
              />

              <Col xs={12} className="pt-2">
                {pbPackage.preBuiltPkgVendors.filter((pv: any) => pv.vendor !== undefined && pv.vendor.vendorType === "Lodging").map(pv =>
                  <PackageVendorCard
                    vendor={pv.vendor}
                  />
                )}
              </Col>
            </div>
          )}
          
          {/* Golf Tab */}
          {pbPackage.preBuiltPkgVendors && pbPackage.preBuiltPkgVendors.some((pv: any) => pv.vendor.vendorType === "Golf") && (
            <div className="pt-2 pb-2">
              <h4
                className="itinerary-font"
                style={{
                  color: style.headerColor,
                }}
              >
                Golf
              </h4>

              <Row
                style={{
                  borderBottom: "2px solid",
                  borderColor: style.borderColor,
                }}
              />

              <Col xs={12} className="pt-2">
                {pbPackage.preBuiltPkgVendors.filter((pv: any) => pv.vendor !== undefined && pv.vendor.vendorType === "Golf").map(pv =>
                  <PackageVendorCard
                    vendor={pv.vendor}
                  />
                )}
              </Col>
            </div>
          )}

          {true && (
            <Button className="orange-button w-100" onClick={() => onSelectedPackage(pbPackage)}>Add To Itinerary</Button>
          )}
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default PackageDetails;